import { API } from 'aws-amplify'

import { MAP_BOX_API_NAME, MAP_BOX_ACCESS_TOKEN } from '../../utils/env'

const getAddressApiRequest = ({ latitude, longitude }) => {
  const apiName = MAP_BOX_API_NAME

  const path = `/geocoding/v5/mapbox.places/${longitude},${latitude}.json`
  const params = {
    queryStringParameters: {
      country: 'nz,au',
      access_token: MAP_BOX_ACCESS_TOKEN,
    },
  }

  return API.get(apiName, path, params)
}

export { getAddressApiRequest }
